import React, { Component } from 'react';
import { CardLayout, TableLayout } from '../containers/Layout';
import { TableRow, TableCell, Button, Box, Grid, TableBody, TableFooter, TableHead, Typography } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';
import SingleBL from '../reapproIntern/SingleBL';
import Currency from '../../../../commonModules/Currency';

const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class SingleReaExtern extends Component {
    state = { 
        BL: false,
        shopDest: {}
    }
    componentDidMount = () => {
        console.log("[INFO] MOUNTING SALE SINGLE ");
        // fetch dest shop
    }
    createProductList = () => {
        const { PRODUCTS, reappro } = this.props

        return reappro.products.map( reapproItem => {
            let prod = PRODUCTS[reapproItem.product_id]
            const ssTt = parseFloat(reapproItem.price) // prix vendu
            const ssTtBeforeMargin = reappro.price_margin ? parseFloat(reapproItem.price / (1 + (reappro.price_margin / 100) ) ) : ssTt // prix vendu avant marge
            const margin = reappro.price_margin ? parseFloat(reapproItem.price * (reappro.price_margin / 100)) : 0 // montant marge

            let PU = ssTtBeforeMargin / reapproItem.quantity
            
            return (
                <TableRow>
                    <TableCell className="text-left">{prod.name}</TableCell>
                    <TableCell>{reapproItem.quantity}</TableCell>
                    
                    <TableCell><Currency value={PU} /></TableCell>
                    <TableCell><Currency value={ssTtBeforeMargin} /></TableCell>
                    <TableCell>{reappro.price_margin || 0} %</TableCell>
                    <TableCell><Currency value={margin} /></TableCell>
                    {/* <TableCell>{shop.TVA || 0} %</TableCell> */}
                    <TableCell><Currency value={ssTt} /></TableCell>
                </TableRow>
            )
        })
    }

    getTotal = () => {
        let total = 0
        let totalBase = 0
        const { reappro } = this.props
        reappro.products.map( reapproItem => {
            const ssTt = parseFloat(reapproItem.price) // prix vendu
            const ssTtBeforeMargin = reappro.price_margin ? 
                parseFloat(reapproItem.price / ( 1 + (reappro.price_margin / 100) ) ) :
                ssTt // prix vendu avant marge          
            
            total += ssTt
            totalBase += ssTtBeforeMargin
            console.log("get total", total, totalBase);
        })
        
        return [
            <Currency value={total} /> ,
            <Currency value={totalBase} /> 
        ]
    }
    
    render(){
        console.log("[STATE] PRODUCT",this.props);
        const { shop, shopDest, reappro} = this.props;
        let total = reappro.total_price
        if( reappro.taxes){
            total += reappro.taxes
        }
        if( reappro.transport){
            total += reappro.transport
        }
        return(
            <SingleTemplate
                shop={shop}    
                shopDest={shopDest}    
                sale={reappro}    
                notif={this.props.notif}
                handleBL={() => this.setState({ BL: !this.state.BL})}
                BL={this.state.BL}
                BLOpt
            >
                {this.state.BL ?
                    <SingleBL 
                        {...this.props}
                        sale={this.props.reappro}
                    />
                :
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell className="text-left">Produit</TableCell>
                            <TableCell>Quantité</TableCell>
                            <TableCell>PU HT</TableCell>
                            <TableCell>Total HT</TableCell>
                            <TableCell colSpan={2}>Marge</TableCell>
                            {/* <TableCell>TVA</TableCell> */}
                            {/* <TableCell>PU Vente</TableCell> */}
                            <TableCell>Total TTC</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.createProductList()}
                        {/* {this.createReturnsList()} */}
                        <TableRow>
                            <TableCell colSpan={7}></TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell colSpan={3} style={{textAlign: "right"}} >Sous Total</TableCell>
                            <TableCell>
                                {this.getTotal()[1]}
                            </TableCell>
                            <TableCell colSpan={2}>
                                <Currency value={(reappro.price_margin ? reappro.total_price * (reappro.price_margin / 100 ) : 0)} />
                            </TableCell>
                            <TableCell className="f-700">
                                {this.getTotal()[0]}
                            </TableCell>
                            
                        </TableRow>
                        <TableRow >
                            <TableCell colSpan={6} style={{textAlign: "right"}} >Transport</TableCell>
                            <TableCell>
                                <Currency value={(reappro.transport || 0)} />
                            </TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell colSpan={6} style={{textAlign: "right"}} >Autres Taxes</TableCell>
                            <TableCell>
                                <Currency value={(reappro.taxes || 0)} />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                    
                    <TableFooter> 
                        {/* <TableRow style={{fontSize:"14px"}}>
                            <TableCell colSpan={6} style={{textAlign: "right"}}>TOTAL</TableCell>
                            <TableCell className="f-700">
                                {formatNumbers.format(total)}
                            </TableCell>
                        </TableRow> */}

                            <TableRow>
                                <TableCell colSpan={this.props.draft ? 2 : 6} style={{textAlign: "right"}}>
                                    <Typography variant="h6">TOTAL</Typography>
                                    </TableCell>
                                <TableCell className="f-700">
                                    <Typography variant="h6"><b><Currency value={(total || 0)} /></b></Typography>
                                </TableCell>
                            </TableRow>
                    </TableFooter>
                </TableLayout>    
                } 
            </SingleTemplate>
        )
    }
}

export default SingleReaExtern;